export const SET_WAITING_REQUESTS = 'SET_WAITING_REQUESTS';
